import React from 'react'

import {
  IStartClosureAction,
  IStartClosureActionLocationMap,
} from '~/client/graph/types.generated'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import ClosureStartSelector from '../components/ClosureStartSelector/ClosureStartSelector'
import { CLOSURE_FIELD_TYPES } from './constants'
import { IActionProps } from './types'

interface IProps extends IActionProps {
  action: IStartClosureAction
}

export default function ClosureStart(props: IProps) {
  const { action, onChange, store, stepId } = props

  const handleMapChange = (
    locationFieldsMap: IStartClosureActionLocationMap[],
  ) => {
    const updatedAction: IStartClosureAction = {
      ...action,
      locationFieldsMap,
    }
    onChange(updatedAction)
  }

  return (
    <div className="row">
      <label>{Localization.translator.closeResources}</label>
      <ClosureStartSelector
        actionArgumentOptions={store.getFieldArgumentOptions(
          CLOSURE_FIELD_TYPES,
          stepId,
        )}
        locationFieldsMap={action.locationFieldsMap}
        onMapChange={handleMapChange}
      />
    </div>
  )
}
